/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterStringType extends models.ParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ParameterStringType");
    }

    getFixupPrototypeFunction() { return ParameterStringType.fixupPrototype; }

    static newInstance(model: Partial<ParameterStringType>): ParameterStringType {
        let obj = Object.assign(new ParameterStringType(), model);
        ParameterStringType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterStringType>): ParameterStringType {
        if (!model) return null;
        return ParameterStringType.newInstance(<ParameterStringType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterStringType) {
        if (!obj) return;

        models.ParameterStringType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterStringType): boolean {
        if (models.ParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterStringType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.constraints) {
            for (let val of this.constraints) {
                models.ParameterConstraintBaseForString.fixupPrototype(val);
            }
        }
    }

    constraints: Array<models.ParameterConstraintBaseForString>;

}
